import Vue from 'vue'

export const getCupons = ({ state, commit }) => {
  return Vue.prototype.axios.post('cupom/get', {}).then(r => {
    commit('setCupons', { cupons: r.data })
    return state.app.cupons
  })
}
export const ativarCupom = ({ state, commit }, { codigo }) => {
  return Vue.prototype.axios.post('cupom/ativar', { codigo }).then(r => {
    return r.data
  })
}
